import { UserOutlined } from "@ant-design/icons"
import { Select, type SelectProps } from "components/Select/Select"
import { VisitPatient } from "interface/visit"
import { memo, useMemo } from "react"
import { useAdminVisitPatients } from "services/visits"

type PatientOption = {
	value: VisitPatient["id"]
	label: string
	email?: string
	/** Both fields the picker searches on, since antd filters a single one. */
	search: string
}

export const SelectVisitPatient = memo(function SelectVisitPatient(
	props: SelectProps<VisitPatient["id"], PatientOption>,
) {
	const { data = [], isFetching } = useAdminVisitPatients()
	const options = useMemo<PatientOption[]>(
		() =>
			data.map(({ id, fullName, email }) => ({
				value: id,
				label: fullName,
				email,
				search: `${fullName} ${email ?? ""}`,
			})),
		[data],
	)

	return (
		<Select<VisitPatient["id"], PatientOption>
			{...props}
			virtual={false}
			loading={isFetching}
			aria-label="Patient"
			placeholder="Select a patient"
			prefix={<UserOutlined aria-hidden />}
			options={options}
			showSearch={{ optionFilterProp: "search" }}
			optionRender={optionRender}
		/>
	)
})

const optionRender = ({ data }: { data: PatientOption }) => (
	<div className="flex flex-col">
		<span>{data.label}</span>
		<span className="text-xs text-navy-60">{data.email}</span>
	</div>
)
